jQuery(function ($) {
  "use strict";

  outlinewp.toggleBlock();
  outlinewp.mixedMediaSliderBlock();
  outlinewp.logoSliderBlock();
  outlinewp.expandCollapseBlock();
  //outlinewp.eventExpandCollapse();
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/interior.js